export default __webpack_public_path__ + "static/media/mute.cd360955.svg";